module.exports = __webpack_public_path__ + "static/media/warning.4f840589.png";